// @flow
/*
import {
		WebComponent
} from 'fg-frontend';
*/

import WebComponent from 'fg-frontend/src/webComponents/WebComponent';
import $ from 'jquery';
import '../plugins/jquery.gm';

export default class GoogleMap extends WebComponent {
	didMount() {
		const {
				startingPositionLng,
				startingPositionLat,
				zoom,
				type,
				title,
				address,
				url,
		} = this.props;

		const $map = $(this.element);
		const $mapContainer = $('.map-container');
		const $card = $('.map-card');
		const $coords = {lat: '49.7701842', lng: '15.6009503'};
		const $zoom = 8;

		window.web = window.web || {};
		var web = window.web;

		web.googlemaps = web.googlemaps || {};
		web.googlemaps.activeMarker = null;

		// listeners on google markers
		web.googlemaps.loadMarkersListeners = {
			click: function (e, data, marker) {

				// clicking on inactive marker
				if (marker.opened) {

					// zavřít kartu a resetnout marker
					web.googlemaps.closeCard(marker);
					// scroll to top map
					web.googlemaps.scrollTo($mapContainer, null);

				} else {

					// inactivate previously activated marker
					if (web.googlemaps.activeMarker && web.googlemaps.activeMarker.opened) {
						web.googlemaps.activeMarker.opened = false;
						web.googlemaps.activeMarker = web.googlemaps.setMarkerIcon(web.googlemaps.activeMarker, false);
						web.googlemaps.activeMarker = null;
					}

					// set current marker active
					web.googlemaps.activeMarker = web.googlemaps.setMarkerIcon(marker, true);
					web.googlemaps.activeMarker = marker;
					marker.opened = true;

					// render custom bubble
					$card.html(web.googlemaps.createCard(data)).show().addClass('active');
					// bind close card event
					web.googlemaps.handleCloseCard(marker);
					// scroll to card
					web.googlemaps.scrollTo($card, null);
				}
			}
		};

		// set activity color of the marker
		web.googlemaps.setMarkerIcon = function (marker, active) {
			if (active) {
				marker.originalData = {
					x: marker.getIcon().origin.x,
					y: marker.getIcon().origin.y,
					url: marker.getIcon().url,
					size: marker.getIcon().size,
					anchor: marker.getIcon().anchor,
					shape: marker.getIcon().shape
				}
			}
			var iconProperties = {
				icon: {
					origin: active ? new google.maps.Point(0, marker.originalData.y - 76) : new google.maps.Point(marker.originalData.x, marker.originalData.y),
					url: marker.originalData.url,
					size: active ? new google.maps.Size(62, 62) : marker.originalData.size,
					anchor: active ? new google.maps.Point(31, 31) : marker.originalData.anchor
				},
				shape: active ? {
					coords: [31, 31, 31],
					type: 'circle'
				} : marker.originalData.shape
			};

			marker.setOptions(iconProperties);

			return active ? marker : null;
		};

		// create googlemap card
		web.googlemaps.createCard = function (data) {
			var str = '';
			// str += '<a class="map-card--close" href="javascript:void(0);">' + web.googlemaps.getText(($("html").attr("lang") || "cs"), "close") + '</a>';
			str += '<div class="map-card__content">';
			str += '<h3 class="map-card__title">' + data.title + '</h3>';
			if (data.address && data.address != "") {
				str += '<p><strong>' + web.googlemaps.getText(($("html").attr("lang") || "cs"), "address") + ':</strong><br>' + data.address + '</p>';
			}
			str += '<p>';
			if (data.mayor && data.mayor != "") {
				str += '<strong>' + web.googlemaps.getText(($("html").attr("lang") || "cs"), "mayor") + ':</strong> ' + data.mayor + '<br>';
			}
			if (data.commander && data.commander != "") {
				str += '<strong>' + web.googlemaps.getText(($("html").attr("lang") || "cs"), "commander") + ':</strong> ' + data.commander;
			}
			str += '</p><p>';
			/*if (data.ico && data.ico != "") {
				str += '<strong>' + web.googlemaps.getText(($("html").attr("lang") || "cs"), "ico") + ':</strong> ' + data.ico + '<br>';
			}*/
			if (data.phone && data.phone != "") {
				str += '<strong>' + web.googlemaps.getText(($("html").attr("lang") || "cs"), "phone") + ':</strong> <span class="phone-number">' + data.phone + '</span><br>';
			}
			if (data.web && data.web != "") {
				str += '<strong>' + web.googlemaps.getText(($("html").attr("lang") || "cs"), "web") + ':</strong> <a href="' + data.web + '" target="_blank" rel="noopener">' + data.web.replace("https://", "").replace("http://", "") + '</a><br>';
			}
			if (data.email && data.email != "") {
				str += '<strong>' + web.googlemaps.getText(($("html").attr("lang") || "cs"), "email") + ':</strong> <a href="mailto:' + data.email + '">' + data.email + '</a>';
			}
			str += '</p>';
			str += '</div>';
			return str;
		};

		// zavírání karty a reset ikony markeru
		web.googlemaps.closeCard = function (marker) {
			web.googlemaps.activeMarker = web.googlemaps.setMarkerIcon(marker, false);
			web.googlemaps.activeMarker = null;
			marker.opened = false;
			$card.empty().hide().removeClass('active');
		};

		// eventy pro zavření karty
		web.googlemaps.handleCloseCard = function (marker) {
			$(document).on('mapCard:close', function (e) {
				web.googlemaps.closeCard(marker);
			});
			$(document).on('click', '.map-card--close', function (e) {
				e.preventDefault();
				$(document).trigger("mapCard:close");
			});
		};

		// centrování mapy na požadovaný marker
		web.googlemaps.focusOnMarker = function (lat, lng, zoom) {
			$map.googlemap('setCenterAndZoom', {
				zoom: zoom,
				latitude: lat,
				longitude: lng
			});
		};

		// zobrazení celé mapy
		web.googlemaps.handleFullMap = function () {
			$(document).on('mapCard:full', function () {
				web.googlemaps.resizeMapOnEvent();
			});
			$(document).on('click', '.map-btn-full', function (e) {
				e.preventDefault();
				$(document).trigger("mapCard:full");
				web.googlemaps.scrollTo($mapContainer, null);
			});
		};

		// odskrolování na požadovaný prvek
		web.googlemaps.scrollTo = function ($element, $offset) {
			let $targetOffset = parseInt($offset) || 0;
			$targetOffset += parseInt($element.offset().top);
			$('html,body').animate({scrollTop: $targetOffset}, 500);
		};

		// resize map
		web.googlemaps.resizeMapOnEvent = function () {
			if (window.innerWidth <= 359) {
				$(document).trigger("mapCard:close");
				$map.googlemap('setCenterAndZoom', {
					lat: startingPositionLat || $coords.lat,
					lng: startingPositionLng || $coords.lng,
					zoom: zoom || 6
				});
			} else if ((window.innerWidth >= 360) && (window.innerWidth <= 579)) {
				$(document).trigger("mapCard:close");
				$map.googlemap('setCenterAndZoom', {
					lat: startingPositionLat || $coords.lat,
					lng: startingPositionLng || $coords.lng,
					zoom: zoom || 6
				});
			} else if ((window.innerWidth >= 580) && (window.innerWidth <= 991)) {
				$(document).trigger("mapCard:close");
				$map.googlemap('setCenterAndZoom', {
					lat: startingPositionLat || $coords.lat,
					lng: startingPositionLng || $coords.lng,
					zoom: zoom || 7
				});
			} else if (window.innerWidth >= 992) {
				$(document).trigger("mapCard:close");
				$map.googlemap('setCenterAndZoom', {
					lat: startingPositionLat || $coords.lat,
					lng: startingPositionLng || $coords.lng,
					zoom: zoom || $zoom
				});
			}
		};

		// lang text into googlemap
		web.googlemaps.getText = function (lang, textId) {
			var structure = {
				"cs": {
					"address": "Adresa",
					"ico": "IČ",
					"mayor": "Starosta sboru",
					"commander": "Velitel sboru",
					"phone": "TEL",
					"web": "Web",
					"email": "E-mail",
					"close": "Zavřít",
					"loading": "Načítání dat"
				}
			};
			return structure[lang][textId];
		};

		// vyhledávání nad mapou
		web.googlemaps.handleSearchInput = function () {
			$(document).on('submit', '.map-filter-search', function (e) {
				e.preventDefault();
				var gmapInputText = $('input[type="text"]', this).val();
				// vybere jen čísla a vytvoří z nich pole
				var nums = gmapInputText.match(/(\d+)/g), psc;
				// vybereme 5-místné číslo, zformátujeme a nahradíme v řetězci
				if (nums !== null) {
					for (var i = 0 ;i < nums.length; i ++) {
					      if (nums[i].length == 5) {
							  psc = nums[i].replace(/(\d{3})/g, '$1 ').replace(/(^\s+|\s+$)/,'');
							  gmapInputText = gmapInputText.replace(nums[i],psc);
						  }
					}
				}
				// console.log(gmapInputText);
				var geocoder = new google.maps.Geocoder();
				geocoder.geocode({'address': gmapInputText + ', Česká republika'}, function (results, status) {
					if (status == google.maps.GeocoderStatus.OK) {
						$map.googlemap('setCenterAndZoom', {
							latitude: results[0].geometry.location.lat(),
							longitude: results[0].geometry.location.lng(),
							zoom: 14
						});
					} else {
						$(document).trigger("mapCard:full");
					}
				});

			});
		};

		// filtrování nad mapou podle typu
		web.googlemaps.handleFilterTypes = function () {
			$(document).on('change', '.map-filter-type__input', function (e) {
				e.preventDefault();
				var filterTypes = $('.map-filters__types');
				var filterValues = [];
				// each checked box
				$('input[type="checkbox"]:checked', filterTypes).each(function () {
					if ($(this).val() != "") {
						filterValues.push(parseInt($(this).val()));
					}
				});
				//- console.log(filterValues);
				// filter objects
				$map.googlemap('filterObjects', 'markers', {
					type: filterValues
				});
			});
		};

		// preloader
		web.googlemaps.mapLoading = function (state, cont) {
			var s = state || '',
					container = cont || $mapContainer,
					l = $('.map-workplace > .map-loading', container);

			// init a append
			if (s == 'init') {
				$('.map-workplace', container).append('<div class="map-loading active"><div class="map-loading__ripple"><div></div><div></div></div><span>' + web.googlemaps.getText(($("html").attr("lang") || "cs"), "loading") + '</span></div>');
			}
			// odebrání
			if (s == 'remove') {
				// this.loading = $('.map-workplace > .map-loading', container);
				l.removeClass('active');
			}
		};

		/**
		 * googlemap base setup
		 */
		$.googlemap.setDefaults({
			mapOptions: {
				startingPosition: {
					lat: startingPositionLat || $coords.lat,
					lng: startingPositionLng || $coords.lng,
					zoom: zoom || $zoom
				},
				minZoom: 5,
				mapTypeControl: false,
				scaleControl: false,
				panControl: false,
				streetViewControl: false,
				zoomControl: true,
				scrollwheel: false,
				fullscreenControl: false,
				styles: [
					{
						"featureType": "administrative",
						"elementType": "labels.text.fill",
						"stylers": [
							{
								"color": "#444444"
							}
						]
					},
					{
						"featureType": "landscape",
						"elementType": "all",
						"stylers": [
							{
								"color": "#f2f2f2"
							}
						]
					},
					{
						"featureType": "poi",
						"elementType": "all",
						"stylers": [
							{
								"visibility": "off"
							}
						]
					},
					{
						"featureType": "road",
						"elementType": "all",
						"stylers": [
							{
								"saturation": -100
							},
							{
								"lightness": 45
							}
						]
					},
					{
						"featureType": "road.highway",
						"elementType": "all",
						"stylers": [
							{
								"visibility": "simplified"
							}
						]
					},
					{
						"featureType": "road.arterial",
						"elementType": "labels.icon",
						"stylers": [
							{
								"visibility": "off"
							}
						]
					},
					{
						"featureType": "transit",
						"elementType": "all",
						"stylers": [
							{
								"visibility": "off"
							}
						]
					},
					{
						"featureType": "water",
						"elementType": "all",
						"stylers": [
							{
								"color": "#46bcec"
							},
							{
								"visibility": "on"
							}
						]
					}
				]
			},
			clustering: {
				enabled: true,
				iconsStyles: [
					{
						textColor: '#ffffff',
						url: '/img/google-map/marker-cluster.png?v2',
						height: 42,
						width: 42,
						textSize: 14
					}
				],
				maxZoom: 17,
				batchSize: 5000,
				batchSizeIE: 5000,
				gridSize: 60
			},
			customInfoWindow: {
				enabled: true,
				boxClass: 'map-infowindow',
				closeClickFunction: function () {
					$(document).trigger("mapCard:close");
				}
			},
			infowindowGroupping: true,
			bubbleContentFormatter: function (mData) {
				var str = '';
				var arrMarkers = mData.additionalGrouppedMarkers;
				if (arrMarkers.length > 0) {
					str += '<h5>Na stejné adrese se také nachází:</h5>';
					// console.log(arrMarkers);
					for (var i = 0; i < arrMarkers.length; i++) {
						var web = '';
						if (arrMarkers[i].web && arrMarkers[i].web != "") {
							web = '- (<a href="' + arrMarkers[i].web + '" target="_blank" rel="noopener">Web</a>)';
						}
						str += '<strong>' + arrMarkers[i].title + '</strong> ' + web + '<br>';
					}
				}
				return str;
			},
			markerTypes: [
				// default marker, empty
				{},
				{
					icon: {
						url: '/img/google-map/markers.png?v2',
						size: new google.maps.Size(33, 33),
						origin: new google.maps.Point(14, 76),
						anchor: new google.maps.Point(16, 16)
					},
					shape: {
						coords: [16, 16, 16],
						type: 'circle'
					}
				},
				{
					icon: {
						url: '/img/google-map/markers.png?v2',
						size: new google.maps.Size(33, 33),
						origin: new google.maps.Point(14, 200),
						anchor: new google.maps.Point(16, 16)
					},
					shape: {
						coords: [16, 16, 16],
						type: 'circle'
					}
				},
				{
					icon: {
						url: '/img/google-map/markers.png?v2',
						size: new google.maps.Size(33, 33),
						origin: new google.maps.Point(14, 324),
						anchor: new google.maps.Point(16, 16)
					},
					shape: {
						coords: [16, 16, 16],
						type: 'circle'
					}
				},
				{
					icon: {
						url: '/img/google-map/markers.png?v2',
						size: new google.maps.Size(33, 33),
						origin: new google.maps.Point(14, 448),
						anchor: new google.maps.Point(16, 16)
					},
					shape: {
						coords: [16, 16, 16],
						type: 'circle'
					}
				},
				{
					icon: {
						url: '/img/google-map/markers.png?v2',
						size: new google.maps.Size(33, 33),
						origin: new google.maps.Point(14, 572),
						anchor: new google.maps.Point(16, 16)
					},
					shape: {
						coords: [16, 16, 16],
						type: 'circle'
					}
				}
			]
		});

		$('html').on('click', '.map-container--inactive', function (e) {
			// loading
			web.googlemaps.mapLoading('init');
			// run google map
			$map.googlemap();
			// responsive resize map
			web.googlemaps.resizeMapOnEvent();
			$(window).on('orientationchange', function () {
				web.googlemaps.resizeMapOnEvent();
			});
			// handler pro návrat na full mapu
			web.googlemaps.handleFullMap();
			// load markers
			if (url === false) {
				// starting position as marker
				$map.googlemap('loadMarkers', {
					data: [
						{
							id: 1,
							lat: startingPositionLat,
							lng: startingPositionLng,
							type: type || 1,
							title: title || '',
							address: address || ''
						}
					],
					disableInfowindow: true,
					listeners: web.googlemaps.loadMarkersListeners || null,
					callback: function () {
						// remove loading
						web.googlemaps.mapLoading('remove');
					}
				});
			} else {
				// load markers from URL
				$map.googlemap('loadMarkers', {
					dataUrl: url,
					dataSetName: 'data',
					listeners: web.googlemaps.loadMarkersListeners || null,
					disableInfowindowCondition: function (data) {
						return !$.isArray(data.additionalGrouppedMarkers) ||
								$.isArray(data.additionalGrouppedMarkers) && data.additionalGrouppedMarkers.length === 0;
					},
					callback: function () {
						// remove loading
						web.googlemaps.mapLoading('remove');
					}
				});
				// bind search input
				web.googlemaps.handleSearchInput();
				// bind filter checkbox
				web.googlemaps.handleFilterTypes();
			}
			$(e.currentTarget).removeClass('map-container--inactive');
		});

		window.google.maps._$map = $map;
	}
}



// WEBPACK FOOTER //
// ./fe/web-default/src/js/components/GoogleMap.js